import { useEffect, useRef } from "react"

// Animate only as content enters view; the server-rendered page is always readable.
export default function useReveal(timeline = false) {
  const ref = useRef(null)
  useEffect(() => {
    const node = ref.current
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)")
    if (!node || preference.matches || !window.IntersectionObserver || !node.animate) return
    const animations = []
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return
      observer.disconnect()
      if (preference.matches) return
      if (timeline) {
        // Emphasize an already-complete line without hiding logos or dates.
        node.querySelectorAll("[data-timeline-shimmer]").forEach(line => {
          animations.push(line.animate([{ opacity: 0 }, { opacity: 0.5, offset: 0.5 }, { opacity: 0 }],
            { duration: 2200, easing: "cubic-bezier(.45,0,.55,1)" }))
        })
      } else {
        animations.push(node.animate([{ opacity: 0, transform: "translateY(16px)" }, { opacity: 1, transform: "translateY(0)" }],
          { duration: 700, easing: "cubic-bezier(.22,1,.36,1)" }))
      }
    }, { threshold: 0.08 })
    observer.observe(node)
    const stop = () => { if (preference.matches) animations.forEach(animation => animation.cancel()) }
    preference.addEventListener("change", stop)
    return () => { observer.disconnect(); animations.forEach(animation => animation.cancel()); preference.removeEventListener("change", stop) }
  }, [timeline])
  return ref
}
